import React from 'react';
import ReactPaginate from 'react-paginate';

type PaginationProps = {
  handlePageClick: (page: number) => void;
  pageCount?: number;
  page?: number;
};

const Pagination: React.FC<PaginationProps> = ({
  handlePageClick,
  page,
  pageCount,
}) =>
  pageCount && pageCount > 1 ? (
    <ReactPaginate
      initialPage={(page || 1) - 1}
      nextLabel="NEXT >"
      onPageChange={({ selected }) =>
        selected + 1 !== page && handlePageClick(selected + 1)
      }
      pageRangeDisplayed={1}
      marginPagesDisplayed={1}
      pageCount={pageCount || 0}
      previousLabel="< PREV"
      pageClassName=""
      pageLinkClassName="flex w-10 h-10 border border-gold items-center justify-center"
      previousClassName=""
      previousLinkClassName="flex border w-max lg:w-40 h-10 border-gold px-2 lg:px-4  items-center justify-center"
      nextClassName=""
      nextLinkClassName="flex border w-max lg:w-40 h-10 border-gold px-2 lg:px-4 items-center justify-center"
      breakLabel="..."
      breakClassName=""
      breakLinkClassName="flex w-10 h-10 border border-gold items-center justify-center"
      containerClassName="flex text-14-26-0.3 justify-center w-auto items-center lg:pr-10"
      activeClassName="active bg-gold outline-none"
      renderOnZeroPageCount={() => null}
    />
  ) : null;

export default Pagination;
